import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import PendingHoldsTable from './components/PendingHoldsTable';

const PendingHoldsIndex = () => (
    <Container className="dashboard">
        <Row>
            <Col md={12}>
                <h3 className="page-title">Pending Holds</h3>
                <h3 className="page-subhead subhead">
                    <Link to="/">Home</Link> / Reports / Pending Holds
                </h3>
            </Col>
        </Row>
        <Row>
            <Col md={12}>
                <Card>
                    <CardBody>
                        <PendingHoldsTable />
                    </CardBody>
                </Card>
            </Col>
        </Row>
    </Container>
);

export default PendingHoldsIndex;
